import { useMemo, useState, useRef, useCallback, useId } from 'react';
import config from '@wearetla/tla-essentials-tools/config';
import { Turnstile as CoreTurnstile } from '@marsidev/react-turnstile';
import { useStorage } from '@wearetla/tla-essentials-tools/utilities/storage';

// Context
import { useTranslation } from '/utilities/i18n';

// Partials
import { Input } from '/views/partials/forms';

export const Turnstile = ({ options, name = 'cf_turnstile_token', onSuccess, onExpire, onTimeout, ...restProps }) => {
  const { language } = useStorage();
  const { t } = useTranslation();
  const [turnstileToken, setTurnstileToken] = useState();
  const generatedId = useId();

  const callbacks = useRef({ onSuccess, onExpire, onTimeout });
  callbacks.current = { onSuccess, onExpire, onTimeout };

  const initialOptions = useRef(options);

  const handleSuccess = useCallback((newToken) => {
    callbacks.current.onSuccess?.(newToken);
    setTurnstileToken(newToken);
  }, []);

  const handleExpire = useCallback(() => {
    callbacks.current.onExpire?.();
    setTurnstileToken(null);
  }, []);

  const handleTimeout = useCallback(() => {
    callbacks.current.onTimeout?.();
    setTurnstileToken(null);
  }, []);

  const memoizedOptions = useMemo(() => ({
    ...(config.turnstile?.widgetOptions ?? {}),
    ...initialOptions.current,
    language,
  }), [language]);

  const siteKey = config.turnstile?.siteKey;

  if (!siteKey) {
    return null;
  }

  return (
    <>
      <CoreTurnstile
        id={generatedId}
        siteKey={siteKey}
        options={memoizedOptions}
        onSuccess={handleSuccess}
        onExpire={handleExpire}
        onTimeout={handleTimeout}
        {...restProps}
      />
      <Input
        name={name}
        type="hidden"
        value={turnstileToken}
        validation={{
          required: t('Kimlik doğrulamasını tamamlamalısınız.'),
        }} 
      />
    </>
  );
};

export default Turnstile;